/**
 * The model for the LSCloud /Account/CreditAccount/:id REST endpoint
 *
 * Copyright 2016 LightSpeed Retail. All rights reserved.
 * Created by kevinford on 2016-03-29.
 */
import Format from 'app/src/data/Format';
import RetailModel from 'app/src/data/models/RetailModel';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class CreditAccount extends RetailModel {
  // Server uses the saleID field as the model's unique identifier. This
  // informs the Backbone.Model of this fact.
  get idAttribute() {
    return 'creditAccountID';
  }

  get defaults() {
    return {
      name: '',
      customerID: 0,
      archived: false,
      balance: Format.parseDecimal('0.0'),
      creditLimit: Format.parseDecimal('0.0'),
      description: '',
      giftCard: false,
    };
  }

  /**
   * Return the url for the CreditAccount endpoint
   */
  url() {
    let URL = URLHelper.getAccountURL('/CreditAccount');
    if (!this.isNew()) {
      URL += `/${this.id}`;
    }
    return `${URL}.json`;
  }

  get retailResponseName() {
    return 'CreditAccount';
  }

  /**
   * Overridden to parse out the superfluous json that the LSCloud returns us
   * @param response - the json object returned from the fetch call before this object has initialized from it
   * @returns {*} the json object that this object will initialize itself from
   */
  parse(response) {
    let parsedResponse = super.parse(response);

    // the Cloud API has a tendency to send all values as strings so let's make sure they're of the proper type
    parsedResponse.creditAccountID = Format.parseInt(parsedResponse.creditAccountID);
    parsedResponse.customerID = Format.parseInt(parsedResponse.customerID);
    parsedResponse.balance = Format.parseDecimal(parsedResponse.balance);
    parsedResponse.creditLimit = Format.parseDecimal(parsedResponse.creditLimit);
    parsedResponse.archived = Format.parseBoolean(parsedResponse.archived);
    parsedResponse.giftCard = Format.parseBoolean(parsedResponse.giftCard);

    return parsedResponse;
  }

  /**
   *  Getter for this account's currently available balance.
   *  @returns {Decimal} - Available account balance.
   */
  get availableCreditBalance() {
    return this.get('creditLimit').minus(this.get('balance'));
  }
}
